import type {
  HttpClient,
  IHttpResponse
} from "@/core/services/protocols/types";
import { IDiagnosticoGateway } from "./DiagnosticoGateway";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class DiagnosticoHttpGateway implements IDiagnosticoGateway {
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private httpClient!: HttpClient;

  baseUrl = "v1/diagnostico";

  async downloadEmpresasReceitaFederal(): Promise<
    IHttpResponse<Blob | undefined>
  > {
    const response = await this.httpClient.get<Blob>({
      url: `${this.baseUrl}/download/receita-federal`,
      config: {
        responseType: "blob"
      }
    });

    return response;
  }

  async download(id: string): Promise<IHttpResponse<Blob | undefined>> {
    const response = await this.httpClient.get<Blob>({
      url: `${this.baseUrl}/download`,
      queryParams: {
        fileId: id
      },
      config: {
        responseType: "blob"
      }
    });

    return response;
  }
}
